// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"635":"643297a8","725":"d229b3e8","871":"643297a8"}[chunkId] + ".chunk.css";
};